(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uplift-cart-discount-badge"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TAG = 'uplift-cdb', LINE = 'uplift-cdt';
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    // Translated labels from the host div above (data-t-*); English only if missing.
    function label(key, fallback) {
      var host = document.querySelector('.uplift-cdb-host');
      return esc((host && host.getAttribute('data-t-' + key)) || fallback);
    }
    // Store's own money format for the presentment currency, learned from a rendered sample
    // (1234567.89), with trailing ",00" dropped like the theme's money_without_trailing_zeros.
    var FMT = null;
    try {
      var sampleEl = document.querySelector('[data-uplift-money-sample]');
      var sample = sampleEl ? JSON.parse(sampleEl.textContent) : '';
      var m = sample.match(/^([^\d]*)(1(\D?)234\D?567(\D)89)([^\d]*)$/);
      if (m) FMT = { pre: m[1], thou: m[3], dec: m[4], suf: m[5] };
      else {
        // Formats without decimals (e.g. NOK "1,234,568 kr"): whole units, store's separator.
        var w = sample.match(/^([^\d]*)1(\D?)234\D?568([^\d]*)$/);
        if (w) FMT = { pre: w[1], thou: w[2], dec: null, suf: w[3] };
      }
    } catch (e) {}
    function money(cents, cur) {
      if (!FMT) {
        var n0 = String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        if (cur === 'GBP') return '£' + n0;
        if (cur === 'USD') return '$' + n0;
        if (cur === 'EUR') return n0 + ' €';
        return n0 + ' kr';
      }
      if (FMT.dec === null) {
        return FMT.pre + String(Math.round(Math.abs(cents) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, FMT.thou) + FMT.suf;
      }
      var whole = String(Math.floor(Math.abs(cents) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, FMT.thou);
      var frac = String(Math.abs(cents) % 100).padStart(2, '0');
      return FMT.pre + whole + (frac === '00' ? '' : FMT.dec + frac) + FMT.suf;
    }
    function couponSaving(cart, code) {
      var apps = cart.cart_level_discount_applications || [];
      for (var i = 0; i < apps.length; i++) { if (apps[i].title === code) return apps[i].total_allocated_amount; }
      return cart.total_discount || 0;
    }
    function render(cart) {
      var d = document.getElementById('cart-drawer');
      if (!d) return;
      var title = d.querySelector('.theme-drawer__title');

      // 1) coupon CODE + amount saved, next to the title
      if (title) {
        var codes = (cart.discount_codes || []).filter(function (c) { return c.applicable; });
        var tag = title.querySelector('.' + TAG);
        if (codes.length) {
          if (!tag) {
            tag = document.createElement('span');
            tag.className = TAG;
            var badge = title.querySelector('.theme-drawer__badge');
            if (badge && badge.parentNode === title) { badge.insertAdjacentElement('afterend', tag); }
            else { title.appendChild(tag); }
          }
          var saved = couponSaving(cart, codes[0].code);
          var safeCode = esc(codes[0].code);
          var html = '<span class="uplift-cdb__code">' + safeCode + '</span>'
                   + (saved ? '<span class="uplift-cdb__amt">−' + money(saved, cart.currency) + '</span>' : '')
                   + '<button type="button" class="uplift-cdb__x" data-uplift-remove aria-label="' + label('remove', 'Remove discount code') + '">×</button>';
          // Compare against what WE last wrote, not tag.innerHTML: the browser re-serializes
          // (data-uplift-remove -> data-uplift-remove="", nbsp -> &nbsp;), so an innerHTML
          // compare never matches -> rewrite -> MutationObserver -> /cart.js -> loop.
          if (tag.__upliftSig !== html) { tag.__upliftSig = html; tag.innerHTML = html; }
        } else if (tag) {
          tag.parentNode.removeChild(tag);
        }
      }

      // 2) Totalt was / now line UNDER the checkout button — FALLBACK ONLY.
      // Shown only when the checkout button isn't already displaying the total
      // (e.g. the button-total script is slow or fails). Normally hidden.
      var anchor = d.querySelector('.cart__ctas');
      var line = d.querySelector('.' + LINE);
      var btn = d.querySelector('.cart__checkout-button, [name="checkout"]');
      // Any digit in the button = it's showing the total ("… — £76" / "… — 899 kr").
      // The label alone ("Checkout" / "Gå til kassen") has no digits. Currency-agnostic.
      var btnHasTotal = btn && /\d/.test(btn.textContent);
      if (!cart.item_count || !anchor || btnHasTotal) {
        if (line) line.parentNode.removeChild(line);
        return;
      }
      if (!line || !d.contains(line)) {
        line = document.createElement('div');
        line.className = LINE;
        anchor.insertAdjacentElement('afterend', line);
      }
      var now = cart.total_price;
      var was = now + (cart.total_discount || 0);
      var htmlT = '<span class="uplift-cdt__label">' + label('total', 'Total') + '</span>'
                + (cart.total_discount > 0 ? '<span class="uplift-cdt__was">' + money(was, cart.currency) + '</span>' : '')
                + '<span class="uplift-cdt__now">' + money(now, cart.currency) + '</span>';
      if (line.__upliftSig !== htmlT) { line.__upliftSig = htmlT; line.innerHTML = htmlT; }
    }

    var busy = false, again = false;
    function refresh() {
      if (!document.getElementById('cart-drawer')) return;
      if (busy) { again = true; return; }
      busy = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { render(c); })
        .catch(function () {})
        .then(function () { busy = false; if (again) { again = false; refresh(); } });
    }
    var t = null;
    function schedule() { if (t) return; t = setTimeout(function () { t = null; refresh(); }, 150); }
    function watch() {
      var d = document.getElementById('cart-drawer');
      if (d && !d.__upliftCdb) {
        d.__upliftCdb = 1;
        new MutationObserver(schedule).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'aria-hidden', 'class'] });
      }
    }
    ['cart:refresh', 'cart:updated', 'cart:change', 'cart:added', 'cart-update'].forEach(function (e) { document.addEventListener(e, schedule); });

    // × removes the discount code, then re-renders the drawer IN PLACE via the
    // theme's own Section Rendering (the drawer stays open, checkout button + total
    // update, gift-app mount comes back). Falls back to a reload if that ever fails.
    function reloadReopen() {
      try { sessionStorage.setItem('upliftCartReopen', '1'); } catch (_) {}
      location.reload();
    }
    document.addEventListener('click', function (e) {
      var x = e.target && e.target.closest ? e.target.closest('[data-uplift-remove]') : null;
      if (!x) return;
      e.preventDefault(); e.stopPropagation();
      x.disabled = true;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) })
        .then(function () { return fetch('/?section_id=cart-drawer-section'); })
        .then(function (r) { return r.text(); })
        .then(function (htmlStr) {
          var fresh = new DOMParser().parseFromString(htmlStr, 'text/html').querySelector('.cart-drawer__inner');
          var live = document.querySelector('#cart-drawer .cart-drawer__inner');
          if (fresh && live) {
            live.replaceWith(fresh);
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            schedule();
          } else {
            if (window.Shopify && window.Shopify.designMode) console.warn('[uplift-cart-discount-badge] .cart-drawer__inner morph target missing — Horizon may have renamed the cart drawer; falling back to reload.');
            reloadReopen();
          }
        })
        .catch(reloadReopen);
    });
    function maybeReopen() {
      var flag; try { flag = sessionStorage.getItem('upliftCartReopen'); } catch (_) {}
      if (!flag) return;
      try { sessionStorage.removeItem('upliftCartReopen'); } catch (_) {}
      var tries = 0;
      (function open() {
        var o = document.querySelector('[on\\:click="#cart-drawer/open"], a[href="/cart"], [aria-controls="cart-drawer"]');
        if (o) { o.click(); } else if (tries++ < 20) { setTimeout(open, 150); }
      })();
    }

    // No cart fetch on page load: the drawer observer refreshes when the drawer opens / re-renders.
    function boot() { watch(); maybeReopen(); }
    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    document.addEventListener('shopify:section:load', function () { watch(); schedule(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uplift-colour-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uplift-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initUpliftReviews() {
      var viewMoreButton = document.querySelector('[js-upr="viewMore"]');
      if (!viewMoreButton || viewMoreButton.upliftBound) return;
      viewMoreButton.upliftBound = true;
      var reviews = [].slice.call(document.querySelectorAll('[js-upr-review="review"]'));
      viewMoreButton.addEventListener('click', function () {
        var allShowing = true;
        var showing = document.querySelectorAll('.upr__review:not(.upr__hidden)').length;
        reviews.forEach(function (review, index) {
          if (index <= showing + 2) { review.classList.remove('upr__hidden'); }
          if (review.classList.contains('upr__hidden')) { allShowing = false; }
        });
        if (allShowing) { viewMoreButton.classList.add('upr__hidden'); }
      });
    }
    function initUpliftLightbox() {
      var dlg = document.querySelector('[data-upr-lightbox]');
      if (!dlg || dlg.__uprBound) return;
      dlg.__uprBound = 1;
      var frame = dlg.querySelector('[data-upr-lightbox-frame]');
      var main = dlg.querySelector('[data-upr-lightbox-main]');
      var thumbs = [].slice.call(dlg.querySelectorAll('.upr__lightbox-thumb'));
      function setActive(key) {
        var chosen = null;
        thumbs.forEach(function (t) {
          var on = key && t.getAttribute('data-upr-key') === key;
          t.setAttribute('aria-current', on ? 'true' : 'false');
          if (on) { chosen = t; }
        });
        if (!chosen && thumbs.length) { chosen = thumbs[0]; chosen.setAttribute('aria-current', 'true'); }
        if (chosen && main) { main.src = chosen.getAttribute('data-full'); }
        if (chosen && chosen.parentNode && chosen.parentNode.scrollWidth > chosen.parentNode.clientWidth) {
          var strip = chosen.parentNode;
          strip.scrollLeft = chosen.offsetLeft - (strip.clientWidth / 2) + (chosen.clientWidth / 2);
        }
      }
      function openLb(key) {
        setActive(key);
        if (dlg.showModal) { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
        document.documentElement.style.overflow = 'hidden';
        if (frame) { frame.scrollTop = 0; }
      }
      function closeLb() {
        if (dlg.close) { dlg.close(); } else { dlg.removeAttribute('open'); }
        document.documentElement.style.overflow = '';
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { setActive(t.getAttribute('data-upr-key')); });
      });
      // Document-level open/close bound ONCE per page (no accumulation on re-render).
      if (!document.__uprLbDoc) {
        document.__uprLbDoc = 1;
        document.addEventListener('click', function (e) {
          var pic = e.target.closest ? e.target.closest('.upr__review-image') : null;
          if (pic) { e.preventDefault(); openLb(pic.getAttribute('data-upr-key')); return; }
          if (e.target.closest && e.target.closest('[data-upr-lightbox-close]')) { closeLb(); }
        });
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          var el = document.activeElement;
          if (el && el.classList && el.classList.contains('upr__review-image')) { e.preventDefault(); openLb(el.getAttribute('data-upr-key')); }
        });
      }
      dlg.addEventListener('click', function (e) { if (e.target === dlg) closeLb(); });
      dlg.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    }
    initUpliftReviews();
    initUpliftLightbox();
    document.addEventListener('shopify:section:load', function () { initUpliftReviews(); initUpliftLightbox(); });
  })();

  } catch(e) { console.error(e); }
})();
})();
